import { CircularProgress } from '@mui/material';
import LoadingOverlay from '../LoadingOverlay';
import { useWLoading } from './WloadingContext';

export default function WLoading() {
  const { open } = useWLoading();

  if (!open) {
    return null;
  }

  return (
    <LoadingOverlay>
      <CircularProgress color="inherit" />
    </LoadingOverlay>
  );
}
